// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// FRONT-END-ONLY SEED DATA (Audit trail — system of record view). Shaped after
// the mockup's auditRows. A real audit feed already exists server-side
// (adminService.getAuditLogs); this seed backs the new Carbon Audit screen
// until that is wired in. See docs/design/hardcoded-frontend-data.md.

import type { AuditEntry } from '../types/alarm';

/** Actor buckets used by the Audit actor filter. */
export const AUDIT_ACTORS = ['all', 'helios', 'operator', 'manager', 'system'] as const;

export const AUDIT_ENTRIES: AuditEntry[] = [
  {
    id: 'aud-1',
    t: '14:25',
    who: 'helios',
    whoLabel: 'Helios AI',
    text: 'Triaged ALM-4471 (CH-2 high condenser pressure), linked prior CHL-FD-001 delta-T drift, proposed SOP-CHL-017.',
    ruleId: 'CHL-FD-003',
    alarmId: 'ALM-4471',
    sev: 'P1',
    asset: 'CH-2 Chiller',
    category: 'Maintenance (safety-adjacent)',
    srcSystem: 'Field Controller',
    sopId: 'SOP-CHL-017',
  },
  {
    id: 'aud-2',
    t: '14:24',
    who: 'system',
    whoLabel: 'Ignition EMS',
    text: 'CH-2 raised high condenser-pressure cutout; chiller locked out.',
    ruleId: 'CHL-FD-003',
    alarmId: 'ALM-4471',
    sev: 'P1',
    asset: 'CH-2 Chiller',
    srcSystem: 'Ignition EMS',
  },
  {
    id: 'aud-3',
    t: '13:36',
    who: 'operator',
    whoLabel: 'Diego Alvarez',
    text: 'Acknowledged ALM-5098 (Generator B auto-start abort); confirmed Gen A armed as active standby.',
    ruleId: 'GEN-ST-002',
    alarmId: 'ALM-5098',
    sev: 'P2',
    asset: 'Generator B',
    srcSystem: 'Routine scheduler',
    sopId: 'SOP-08',
  },
  {
    id: 'aud-4',
    t: '13:05',
    who: 'helios',
    whoLabel: 'Helios AI',
    text: 'Triaged ALM-4468 (UPS-2 cell over-temperature), proposed SOP-11 battery string isolation.',
    alarmId: 'ALM-4468',
    sev: 'P2',
    asset: 'UPS-2 Vertiv Liebert',
    srcSystem: 'Field Controller',
    sopId: 'SOP-11',
  },
  {
    id: 'aud-5',
    t: '11:40',
    who: 'helios',
    whoLabel: 'Helios AI',
    text: 'Triaged ALM-4459 (Bus-A B3 lug hot-spot), proposed SOP-17 with a planned maintenance window.',
    alarmId: 'ALM-4459',
    sev: 'P3',
    asset: 'Eaton Switchgear Bus-A',
    srcSystem: 'Ignition EMS',
    sopId: 'SOP-17',
  },
  {
    id: 'aud-6',
    t: '08:48',
    who: 'system',
    whoLabel: 'Routine scheduler',
    text: 'Routine SOP-30 promoted rack A-14 inlet reading to alarm ALM-4450 after three consecutive exceedances.',
    alarmId: 'ALM-4450',
    sev: 'P4',
    asset: 'Rack A-14',
    srcSystem: 'Routine scheduler',
    sopId: 'SOP-30',
  },
];
